import {DialogContent, DialogTitle, MenuItem, Select, Typography} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import React, {useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {ByOthersSetting} from "../../../../api/Openings";

const options: {value: ByOthersSetting; label: string}[] = [
    {value: "none", label: "(none)"},
    {value: "byUs", label: "By Us"},
    {value: "byOthers", label: "By Others"},
    {value: "inherit", label: "Inherit"},
];

// applyByOthers returns the new by-others override for the given setting. "byUs"/
// "byOthers" set an explicit override; "inherit" clears the override (null) so the
// value inherits from the series' supplier category; "none" leaves it untouched.
export function applyByOthers(setting: ByOthersSetting, current: boolean | null): boolean | null {
    switch (setting) {
        case "byUs": return false;
        case "byOthers": return true;
        case "inherit": return null;
        default: return current;
    }
}

export function SetByOthers(props: {
    onCancel: () => void;
    onSubmit: (input: {door: ByOthersSetting; frame: ByOthersSetting}) => Promise<void>;
}) {
    const [door, setDoor] = useState<ByOthersSetting>("none");
    const [frame, setFrame] = useState<ByOthersSetting>("none");

    const submit = useAsyncAction(async (input: {door: ByOthersSetting; frame: ByOthersSetting}) => {
        await props.onSubmit(input);
    }, []);

    const noChanges = door === "none" && frame === "none";

    const onSubmit = () => {
        if(noChanges) return;
        submit.callback({door, frame});
    };

    return (
        <Dialog2 open onClose={() => props.onCancel()} maxWidth="xs" fullWidth onEnterPress={onSubmit}>
            <DialogTitle>Set By-Us</DialogTitle>
            <DialogContent>
                <div style={{display: "flex", flexDirection: "column", gap: 12, paddingTop: 8}}>
                    <Row label="Doors">
                        <Select
                            size="small"
                            value={door}
                            onChange={e => setDoor(e.target.value as ByOthersSetting)}
                            style={{minWidth: 140}}
                        >
                            {options.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                        </Select>
                    </Row>
                    <Row label="Frames">
                        <Select
                            size="small"
                            value={frame}
                            onChange={e => setFrame(e.target.value as ByOthersSetting)}
                            style={{minWidth: 140}}
                        >
                            {options.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
                        </Select>
                    </Row>
                </div>
            </DialogContent>
            <SmoothActionBar
                loading={submit.loading}
                error={submit.error}
                onCancel={() => props.onCancel()}
                onSubmit={onSubmit}
                actionName="Update"
                submitDisabled={noChanges}
            />
        </Dialog2>
    );
}

function Row(props: {label: string; children: React.ReactNode}) {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
        }}>
            <Typography variant="body2">{props.label}</Typography>
            {props.children}
        </div>
    );
}
